import { render, staticRenderFns } from "./CollapseDivTwo.vue?vue&type=template&id=2d3175f2"
import script from "./CollapseDivTwo.vue?vue&type=script&lang=js"
export * from "./CollapseDivTwo.vue?vue&type=script&lang=js"
import style0 from "./CollapseDivTwo.vue?vue&type=style&index=0&id=2d3175f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports